import API from "../API";
import getUrl from "./utils/getUrl";
import appendApolloClientValues from "./utils/appendApolloClientValues";
import setIfNotSet from "../../setIfNotSet";
var graph = function (_a, options) {
    var query = _a.query, variables = _a.variables;
    if (options === void 0) { options = {}; }
    setIfNotSet(options, "isGraphQuery", true);
    return appendApolloClientValues(options).then(function () {
        return API.post(getUrl(), { query: query, variables: variables }, options).then(function (res) { return res.data.data; });
    });
};
export default graph;
export { getUrl };
